import { render, staticRenderFns } from "./BoxCard.vue?vue&type=template&id=be52512a"
import script from "./BoxCard.vue?vue&type=script&lang=js"
export * from "./BoxCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports